import React, { useEffect, useRef, useState } from 'react';
import { Button, Table, Card,Tabs,Tab } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Graphic from "@arcgis/core/Graphic.js";
import Circle from "@arcgis/core/geometry/Circle.js";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import Color from "@arcgis/core/Color.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters.js";
import RouteParameters from "@arcgis/core/rest/support/RouteParameters.js";
import * as route from "@arcgis/core/rest/route.js";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol.js";
import * as identify from "@arcgis/core/rest/identify.js";
import FeatureSet from "@arcgis/core/rest/support/FeatureSet.js";
import Point from "@arcgis/core/geometry/Point.js";
import config from './Config.json';
import './buffer.css';
var array=[];
var list=[];
// var buffergeomGraphic;
// var incidentGL_MB;
//  var routeGL_MB;
// var finalSchoolsGL_2KM_MB;
var count = 0;
var bufferIndex = 0;
var startPt;
var nfbufferIndex;
var globalresults = [], finalSchool_2km = [], finalSchool_5km = [];
var routeGraphics_2km = [], routeGraphics_5km = [];

    const NearByRoute=(mapView)=>{

        const [activeTab, setActiveTab] = useState("buffer");
        const [Selvalue, setSelvaue] = useState(0);
        const [distance,setDistance]=useState();
        const [data,setData] = useState(config)
      const [isTableCardOpen, setIsTableCardOpen] = useState(false);
      const [fields, setFields] = useState([]);
      const [resdata, setResdata] = useState([]);

        const [atmfields, setAtmFields] = useState([]);
      const [atmdata, setAtmResdata] = useState([]);

      const [mithrafields, setithraFields] = useState([]);
      const [mithradata, setMithraResdata] = useState([]);


      const [isTablebranchOpen, setIsTablebranchOpen] = useState(false)
      const [isTablemithtaOpen, setIsTablemithraOpen] = useState(false)
      const [isTableAtmOpen, setIsTableAtmhOpen] = useState(false)

        
        useEffect(()=>{
          // buffergeomGraphic = new GraphicsLayer();
          // buffergeomGraphic.listMode = "hide";

          //  incidentGL_MB = new GraphicsLayer();
          // incidentGL_MB.id = "incidentGL_MB";
          // incidentGL_MB.listMode = "hide";

          //  finalSchoolsGL_2KM_MB = new GraphicsLayer();
          // finalSchoolsGL_2KM_MB.id = "finalSchoolsGL_2KM_MB";

          //  routeGL_MB = new GraphicsLayer();
          // routeGL_MB.id = "routeGL_MB";
          
        },[])

        var highlightpointSymbol = {
          type: "simple-marker",
          style: "circle",
          size: 12,
          color: [255, 255, 0],
          outline: {
              style: "solid",
              color: [0, 255, 255],
              width: 3
          }
      };
        var routeParams = new RouteParameters();
        routeParams.stops = new FeatureSet();
        routeParams.outSpatialReference = mapView.view.spatialReference;

        const ExecuteFeatures=()=>{

          if(Selvalue == 0 || Selvalue == ""){
            alert("Please Select Feature Type");
            return false;
          }
          routeParams.stops.features.pop();
            routeParams.stops.features.pop();
          nfbufferIndex = 1;
          setIsTableCardOpen(true);
          var bufferFeatureEvent = mapView.view.on("click", (event) => {
            bufferFeatureEvent.remove();
            const start = new Graphic({
              geometry: { type: "point", longitude: 74.36, latitude:25.36 }
            });

             nfidentifyFeatures(event);

          });



        
   
          
        

        }


        function nfidentifyFeatures(evt) {
          
         mapView.view.map.findLayerById("incidentGL_MB").graphics.removeAll();
         mapView.view.map.findLayerById("finalSchoolsGL_2KM_MB").graphics.removeAll();
         mapView.view.map.findLayerById("routeGL_MB").graphics.removeAll();
          startPt = evt.mapPoint;
          mapView.view.map.findLayerById("incidentGL_MB").add(getGraphic(startPt, "markerSymbol", null));
          //routeParams.stops.features.push(incidentGL_MB.graphics[0]);
          var pointGraphic = new Graphic({
              geometry: startPt
          });
          //mapView.view.map.add(incidentGL_MB);
          routeParams.stops.features.push(startPt);
         
              loopnfbuufer();
      }

                function loopnfbuufer() {
            

                  var bufferGeomCollection = [];
                  var bufferGeometry = geometryEngine.buffer(startPt, nfbufferIndex, "kilometers");
                  bufferGeomCollection.push(bufferGeometry);
                  pdsnfshowBuffer(bufferGeomCollection);
              }

              function pdsnfshowBuffer(bufferedGeometries) {
                bufferedGeometries.map(function (geometry) {
                    pdsnfintersectionGp(geometry);
                });
            }



            function pdsnfintersectionGp(geometry) {

              //var bufferidentifyTask = new IdentifyTask(mapjson.mapService[0].url + "?Token=" + mapjson.mapService[0].token);
              var bufferidentifyParams = new IdentifyParameters();
              bufferidentifyParams.tolerance = 1;
              bufferidentifyParams.returnGeometry = true;
              bufferidentifyParams.layerIds = [Selvalue];//pds layer id=7
              bufferidentifyParams.layerOption = "all";
              bufferidentifyParams.geometry = geometry;
              bufferidentifyParams.mapExtent = mapView.view.extent// dlayer.fullExtent;
              document.getElementById('pdsnftblMultipleBuffer_2km').innerHTML = '';
              setIsTableCardOpen(true);
              routeGraphics_2km = [];

              identify.identify(data.layerForQuery.DataLayer[0].Url + "?Token=" + data.layerForQuery.DataLayer[0].Token, bufferidentifyParams).then(function (res) {
                  //bufferidentifyTask.execute(bufferidentifyParams).addCallback(function (response) {
                  var response = res.results;
                  if (response.length > 0) {
                    globalresults = response;

                    if(Selvalue == 5){

                    document.getElementById('pdsnftblMultipleBuffer_2km').append(generateTable(data.layerForQuery.DataLayer[0].infotemplates[0].fields, response))
                    
                     
                      var content = document.getElementById('pdsnftdMB_2kmHeader').innerHTML= "BankBranchs within " + ((nfbufferIndex * 1000) / 1000) + "km street distance: " + globalresults.length;
                    }
                    else if(Selvalue == 6){
                      document.getElementById('pdsnftblMultipleBuffer_2km').append(generateTable(data.layerForQuery.DataLayer[0].infotemplates[1].fields, response))
                    
                     
                      var content = document.getElementById('pdsnftdMB_2kmHeader').innerHTML= "ATMs within " + ((nfbufferIndex * 1000) / 1000) + "km street distance: " + globalresults.length;
                 
                    }
                    else if(Selvalue == 7){

                      document.getElementById('pdsnftblMultipleBuffer_2km').append(generateTable(data.layerForQuery.DataLayer[0].infotemplates[2].fields, response))
                      var content = document.getElementById('pdsnftdMB_2kmHeader').innerHTML= "Bankmitras within " + ((nfbufferIndex * 1000) / 1000) + "km street distance: " + globalresults.length;
                 
                    }
                      //  content("PDS within " + ((nfbufferIndex * 1000) / 1000) + "km street distance: " + globalresults.length);
                      nfbufferIndex = 1;
                      var formheader;
                      var str;

                  
                      let tablestr = "<tbody>", count = 0; finalSchool_2km = [];
                      var promiseArray = [];
                      for (var j = 0; j < globalresults.length; j++) {
                          count++;
                          finalSchool_2km.push(globalresults[j].feature);
                          mapView.view.map.findLayerById("finalSchoolsGL_2KM_MB").add(getGraphic(globalresults[j].feature.geometry, "highlightpointSymbol", null));
                          mapView.view.map.findLayerById("finalSchoolsGL_2KM_MB").add(getGraphic(globalresults[j].feature.geometry, "markerSymbol_1", null));
                          //mapView.view.map.add(finalSchoolsGL_2KM_MB);

                          //if (sourcemultilayer_text == "School") {
                        
                          //}
                        // tablestr = tablestr + row;
                          if (routeParams.stops.features.length > 1) {
                              routeParams.stops.features.pop();
                          }
                          routeParams.stops.features.push(finalSchool_2km[finalSchool_2km.length - 1].geometry);


                          
                            const routeParams1 = new RouteParameters({
                              stops: new FeatureSet({ features: [routeParams.stops.features[0], routeParams.stops.features[1]] }),
                              outSpatialReference: { wkid: 3857 },
                              returnDirections: true
                            });


                                                         // Define Start and Stop Points
                                                         const start = new Graphic({
                                                          geometry: { type: "point", longitude: startPt.longitude, latitude:startPt.latitude }
                                                        });
                                                      
                                                        const stop = new Graphic({
                                                          geometry: { type: "point", longitude:globalresults[j].feature.geometry.longitude, latitude: globalresults[j].feature.geometry.latitude }
                                                        });
                                                      
                                                      
                                                        // Solve Route
                                                      
                                                          const routeParams2 = new RouteParameters({
                                                            stops: new FeatureSet({ features: [start, stop] }),
                                                            outSpatialReference: { wkid: 3857 },
                                                            returnDirections: true
                                                          });
                          //promiseArray.push(routeTask.solve(routeParams));
                        //  route.solve(data.layerForQuery.Route.Url, routeParams1).then(function (values) {
                          route.solve(data.layerForQuery.Route.Url, routeParams2)
                          .then(function(values) {
                              routeGraphics_2km.push(values.routeResults[0].route);
                             // for (var index = 0; index < routeGraphics_2km.length; index++)
                               // document.getElementById("distin15km_" + index).innerHTML((routeGraphics_2km[index].attributes.Total_Length / 1000).toFixed(2));
                              //document.getElementById("bodyloadimg").hide();
                             // document.getElementById('bodyloadimg').style.display = 'none';
                          });



                                     
                                          
                                              // route.solve(data.layerForQuery.Route.Url, routeParams2)
                                              //   .then(function(result) {
                                              //     if (result.routeResults.length > 0) {
                                              //       const routeGraphic = new Graphic({
                                              //         geometry: result.routeResults[0].route.geometry,
                                              //         symbol: {
                                              //           type: "simple-line",
                                              //           color: [0, 0, 255, 0.7],
                                              //           width: 4
                                              //         }
                                              //       });
                                              //      mapView.view.map.graphic.add(routeGraphic);
                                              //     }
                                              //   })
                                              //   .catch(function(error) {
                                              //     console.error("Route solving error:", error);
                                              //   });
                      }
                      //Promise.all(promiseArray).then(function (values) {
                      //    routeGraphics_2km = values.map(a => a.routeResults[0].route);
                      //    $.each(routeGraphics_2km, function (index, item) {
                      //        $("#distin15km_" + index).html((item.attributes.Total_Length / 1000).toFixed(2));
                      //    });
                      //    //console.log(values);
                      //    //$("#loading").hide();
                      //}, function (reason) {
                      //    $("#loading").hide();
                      //    //console.log(reason);
                      //});
                      tablestr += '</tbody>';
                      tablestr = formheader + tablestr;


                      if (count > 0) {
                      //  document.getElementById('pdsnftblMultipleBuffer_2km').append(tablestr);
                          //$('#tdMB_5kmHeader').html("Schools within 5km street distance: " + globalresults.length);
                          var table = document.getElementById('pdsnftblMultipleBuffer_2km');
                          var rows = table.getElementsByTagName("tr");


                          //document.getElementById('pdsnftblMultipleBuffer_2km').show();
                          document.getElementById('pdsnftblMultipleBuffer_2km').style.display = 'block';
                          sortTable_mb(2, "pdsnftblMultipleBuffer_2km");
                      } else {
                          loopnfbuufer();
                          nfbufferIndex++;
                          //alert("No fetures found within " + ((nfbufferIndex*1000) / 1000) + "km distance");
                      }
                  }
                  else {
                      loopnfbuufer();
                      nfbufferIndex++;
                      //alertify.alert("Warning", "No GP Found");
                  }


              });

          };


          function generateTable(headers, data) {
            const table = document.createElement("table");
            table.border = "1";
        
            // Create table header
            const thead = document.createElement("thead");
            const headerRow = document.createElement("tr");
            headers.forEach(header => {
                const th = document.createElement("th");
                th.textContent = header.alias;
                headerRow.appendChild(th);
            });
            thead.appendChild(headerRow);
            table.appendChild(thead);
        
            // Create table body
            const tbody = document.createElement("tbody");
            data.forEach(row => {
                const tr = document.createElement("tr");
                headers.forEach(header => {
                    const td = document.createElement("td");
                    td.textContent = row.feature.attributes[header.name] || "";
                    tr.appendChild(td);
                });
                tbody.appendChild(tr);
            });
            table.appendChild(tbody);
        
            return table;
        }


       // document.getElementById('pdsnftblMultipleBuffer_2km').addEventListener('click', function (e) {

          const zoomroute=(e)=>{
          let target = e.target;
          while (target && target.tagName !== 'TR') {
              target = target.parentElement;
          }
          
          if (target) {
              let index = Array.from(target.parentElement.children).indexOf(target);
              mapView.view.map.findLayerById("routeGL_MB").graphics.removeAll();
             // mapView.view.map.remove(routeGL_MB);
              
              let directionpath = new Graphic({
                  geometry: routeGraphics_2km[index].geometry,
                  symbol: {
                    type: "simple-line",
                    color: [0, 0, 255, 0.7],
                    width: 4
                  }
              });
              mapView.view.map.findLayerById("routeGL_MB").add(directionpath);
          }
      }



          
        function getGraphic(geometry, type, attributes) {

          var symbol;
          if (type == "esriGeometryPolygon") {
              if (bufferIndex == 0) {
                  symbol = {
                      type: "simple-fill",
                      style: "solid",
                      color: [255, 0, 0, 0.5],
                      outline: {
                          style: "solid",
                          color: [255, 0, 0],
                          width: 2
                      }
                  };
              }
              else if (bufferIndex == 1) {
                  symbol = {
                      type: "simple-fill",
                      style: "solid",
                      color: [0, 0, 255, 0.5],
                      outline: {
                          style: "solid",
                          color: [0, 0, 255],
                      }
                  };
              }

          } else if (type == "esriGeometryPolyline") {
              symbol = {
                  type: "simple-line"
              };
          } else if (type == "markerSymbol") {
              symbol = new PictureMarkerSymbol('https://static.arcgis.com/images/Symbols/Basic/RedStickpin.png', 200, 200);
              symbol.xoffset = 0;
              symbol.yoffset = 5;
          } else if (type == "markerSymbol_1") {
              symbol = new PictureMarkerSymbol('https://static.arcgis.com/images/Symbols/Basic/SpringGreenStickpin.png', 200, 200);
              symbol.xoffset = 0;
              symbol.yoffset = 5;
          } else if (type == "highlightpointSymbol") {
              symbol = highlightpointSymbol;
          }
          else if (type == "redmarker") {
              symbol = new PictureMarkerSymbol('https://static.arcgis.com/images/Symbols/Shapes/RedPin1LargeB.png', 200, 200);
              symbol.xoffset = 0;
              symbol.yoffset = 5;
          }
          else if (type == "greenmarker") {
              symbol = new PictureMarkerSymbol('https://static.arcgis.com/images/Symbols/Shapes/GreenPin1LargeB.png', 200, 200);
              symbol.xoffset = 0;
              symbol.yoffset = 5;
          }
          else {
              symbol = {
                  type: "simple-marker",
                  style: "square",
                  size: 10,
                  color: [0, 255, 0, 0.25],
                  outline: {
                      style: "solid",
                      color: [255, 0, 0],
                      width: 1
                  }
              }

          }

          var graphic = new Graphic({ geometry: geometry, symbol: symbol });
          if (attributes != "" && attributes != null) {
              graphic.attributes = attributes;
          }
          return graphic;
      }


      function sortTable_mb(n, tableId) {
        var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = document.getElementById(tableId);
        switching = true;
        // Set the sorting direction to ascending:
        dir = "asc";
        /* Make a loop that will continue until
        no switching has been done: */
        while (switching) {
            // Start by saying: no switching is done:
            switching = false;
            rows = table.rows;
            /* Loop through all table rows (except the
            first, which contains table headers): */
            for (i = 1; i < (rows.length - 1); i++) {
                // Start by saying there should be no switching:
                shouldSwitch = false;
                /* Get the two elements you want to compare,
                one from current row and one from the next: */
                x = rows[i].getElementsByTagName("TD")[n];
                y = rows[i + 1].getElementsByTagName("TD")[n];
                /* Check if the two rows should switch place,
                based on the direction, asc or desc: */
                if (dir == "asc") {
                    if (x.innerText.toLowerCase() > y.innerText.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir == "desc") {
                    if (x.innerText.toLowerCase() < y.innerText.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                }
            }
            if (shouldSwitch) {
                /* If a switch has been marked, make the switch
                and mark that a switch has been done: */
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                // Each time a switch is done, increase this count by 1:
                switchcount++;
            } else {
                /* If no switching has been done AND the direction is "asc",
                set the direction to "desc" and run the while loop again. */
                if (switchcount == 0 && dir == "asc") {
                    dir = "desc";
                    switching = true;
                }
            }
        }
    }

        const Execute=()=>{
          var bufferEvent = mapView.view.on("click", (event) => {
            bufferEvent.remove();
            setIsTablebranchOpen(false);
            setIsTableAtmhOpen(false);
            setIsTablemithraOpen(false);

            var circleSymb = new SimpleFillSymbol(
              SimpleFillSymbol.STYLE_SOLID,
              new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
                  new Color([0, 255, 255]), 4), new Color([229, 255, 255, 0.4])
          );

          //   var buffergeom = new Circle({
          //     center: event.mapPoint,
          //     geodesic: true,
          //     radius: parseInt(document.getElementById("txtDistance")),
          //     radiusUnit: "Kilometers"
          // });

         var circleGeometry = new Circle({
            center:  event.mapPoint,
            geodesic: true,
            numberOfPoints: 100,
            radius: parseInt(document.getElementById("txtDistance").value),
            radiusUnit: "kilometers"
          })

          mapView.view.graphics.removeAll();
          // buffergeomGraphic = new Graphic(
          //                           { 
          //                             geometry:circleGeometry, 
          //                             symbol:circleSymb
          //                         });
          // mapView.view.graphics.add(buffergeomGraphic);

            if(Selvalue.length >1){

              var dtparams = new Query({
                outFields: ["*"],
                where: "1=1",
                geometry: circleGeometry,
              });
  
              query
                .executeQueryJSON(data.layerForQuery.DataLayer[0].Url+"/"+1+"?token=", dtparams)
                .then(response => Results(response, "Bank"))
                .catch();

                query
                .executeQueryJSON(data.layerForQuery.DataLayer[0].Url+"/"+2+"?token=", dtparams)
                .then(response => Results(response, "ATM"))
                .catch();


                query
                .executeQueryJSON(data.layerForQuery.DataLayer[0].Url+"/"+3+"?token=", dtparams)
                .then(response => Results(response, "Mithra"))
                .catch();

                count =0

             

            

            }else{

                  var dtparams = new Query({
                    outFields: ["*"],
                    where: "1=1",
                    geometry: circleGeometry,
                  });
      
                  query
                    .executeQueryJSON(data.layerForQuery.DataLayer[0].Url+"/"+Selvalue+"?token=", dtparams)
                    .then(response => Resultsone(response))
                    .catch();

            }



            function Results(response,param){
              
              list = [];
              array = [];
                  setIsTableCardOpen(true);
                  console.log(response);
                

                let larArray = response.features;
                  //showthepointonmap(values[j], "esriGeometryPoint");
                  for(var m = 0; m < larArray.length; m++) {
                      array.push(larArray[m]);
                  }
                  array.forEach(function (item) {
                      list.push(item.attributes);
                  });
                  console.log(list);
                  if(param === "Bank"){
                    if(list.length >0){
                   setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
                  
                   setResdata(list);
                   setIsTablebranchOpen(true);
                   }
                  }
                  else if(param === "ATM"){
                    if(list.length >0){
                    setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
                    setAtmResdata(list);
                    setIsTableAtmhOpen(true)
                    }

                  }
                  else if(param == "Mithra"){
                    if(list.length >0){
                    setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
                    setMithraResdata(list);
                    setIsTablemithraOpen(true);
                    }

                  }

              
            }

            function Resultsone(response){
              
              count++;
              list = [];
              array = [];
                  setIsTableCardOpen(true);
                  console.log(response);
                

                let larArray = response.features;
                  //showthepointonmap(values[j], "esriGeometryPoint");
                  for(var m = 0; m < larArray.length; m++) {
                      array.push(larArray[m]);
                  }
                  array.forEach(function (item) {
                      list.push(item.attributes);
                  });
                  console.log(list);
                  

                   if(Selvalue === "1"){

                    setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
                    setResdata(list);
                    setIsTablebranchOpen(true);
                   }
                   else if(Selvalue === "2"){
                     setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
                     setAtmResdata(list);
                     setIsTableAtmhOpen(true);
 
                   }
                   else if(Selvalue == "3"){
                     setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
                     setMithraResdata(list);
                     setIsTablemithraOpen(true);
 
                   }
                

            }
            
 
           })
        }


        const SelLayers = (evt)=>{
          setSelvaue(evt.target.value);
        }
        const handleCloseTableCard = () => {
          setIsTableCardOpen(false); // Close the table card
        
          

         // mapView.view.graphics.removeAll();
      };

      const RowHandler=(latitude,longitude)=>{
   

       //zoomGraphicLayer.graphics.removeAll();
      mapView.view.map.findLayerById("Zoompoint").graphics.removeAll();
        const point = new Point({
          longitude:longitude,
          latitude: latitude
        });

        mapView.view.goTo({
            target: point,
            zoom: 15 // Zoom level you desire
          });
          var zoomsymbol = new SimpleMarkerSymbol({
            // orange
            outline: {
              color: [255,0,0], // white
              width: 5
            }
          });
    
          mapView.view.map.findLayerById("Zoompoint").add(new Graphic(
            {geometry:point,
              symbol: zoomsymbol
              }
            ));
      }

      const reset=()=>{
        setIsTableCardOpen(false); // Close the table card
        setIsTablebranchOpen(false);
        setIsTableAtmhOpen(false);
        setIsTablemithraOpen(false);
        mapView.view.map.findLayerById("incidentGL_MB").graphics.removeAll();
        mapView.view.map.findLayerById("finalSchoolsGL_2KM_MB").graphics.removeAll();
        mapView.view.map.findLayerById("routeGL_MB").graphics.removeAll();
        mapView.view.graphics.removeAll();
        mapView.view.map.findLayerById("Zoompoint").graphics.removeAll();
      }
        
        return(
            <div>

        
                <select id="ddBufferTargetLyr" title="Target Layer" className='form-select' style={{ width: "100%" }} onChange={SelLayers}>
                            <option value="0">Select Target Layer</option>
                            <option value="5">BANKBRANCH</option>
                            <option value="6">ATM</option>
                            <option value="7">BANKMITRA</option>                                                
                          

                        </select>
                        <br></br>
                    
                        <div>
                            <input id="btnBufferQuery" type="button" value="Execute" onClick={ExecuteFeatures} style={{"margin-right": "10px","background-color":"#0c3793","color":"white"}}/>
                            <input id="btnBufferReset" type="button" value="Reset" onClick={reset} style={{"background-color":"#0c3793", "color":"white"}} />
                        </div>
                    

                            {/* Table Card */}
                                    {isTableCardOpen && (
                                        <Card
                                            style={{
                                                position: 'fixed',
                                                bottom: '20px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: '80%',
                                                zIndex: 1060,
                                                borderRadius: '10px'
                                            }}
                                        >
                                            <Card.Header className="d-flex justify-content-between" style={{ backgroundColor: "#dcf5f2", height: "45px",  }}>
                                                <h5 style={{fontSize: "large", fontWeight: "700"}}>Result Table</h5>
                                                <Button variant="link" onClick={handleCloseTableCard}>
                                                    <i className="material-icons" style={{ fontSize: '24px' }}>close</i>
                                                </Button>
                                            </Card.Header>
                                            <Card.Body >

                     <div class="accordion-button question-toggle collapsed" data-bs-toggle="collapse"
                         data-bs-parent="#pdsnffaqAccordion" data-bs-target="#pdsnfquestion0" style={{"background-color": "beige"}}>
                        <h4 style={{"font-size": "14px"}}>
                            <a href="#" id="pdsnftdMB_2kmHeader" class="ing"></a>
                        </h4>

                    </div>
                    <div id="pdsnfquestion0" class="accordion-collapse collapse" style={{"height": "0px"}}>
                        <div class="panel-body">


                            <div style={{"overflow": "auto", "height": "12vh"}}>
                              
                                <table class="table table-responsive table-striped table-bordered table-hover table-condensed bufferreport_noScroll"
                                       id="pdsnftblMultipleBuffer_2km" onClick={zoomroute} border="1" style={{"display": "none"}}></table>
                            </div>
                        </div>
                    </div>
                  



    
                                            </Card.Body>
                                        </Card>
                                    )}
              
    
    
            </div>
        )
    }

    export default NearByRoute;